module.exports = __webpack_public_path__ + "img/sign-62.a1da7431.jpg";